import React, { useState, useEffect } from "react";
import Navigation from "../partials/Navigation";
import { getWithExpiry, setWithExpiry } from '../common';
import {Helmet} from "react-helmet";
import HorizontalNav from "../partials/Dashboard/HorizontalNav";

const BookCoach = () => {

    const [pageContent, setPageContent] = useState('');

    useEffect(() => {

        const savedPageContent = getWithExpiry( 'book_coach_page_content' );

        if ( savedPageContent ) {
            
            setPageContent( savedPageContent );
            
            return;
        
        } else {

            (async () => {
				
                const response = await fetch(`https://learn.sustainchange.se/wp-json/wp/v2/pages?slug=boka-coach-konsult`);
                
                const pageResponse = await response.json();
    
                if ( pageResponse ) {
    
                    if ( pageResponse[0] ) {

                        const pageData = {
                            'content': pageResponse[0].content.rendered,
                            'title': pageResponse[0].title.rendered.replaceAll('&#038;', '&'),
                            'image': pageResponse[0].sy_fimg_url
                        }

                        setPageContent( pageData );
                        setWithExpiry( 'book_coach_page_content', pageData );
                    }
    
                }
    
            })()

        }

    }, []);

    return (
        <div className="main-wrapper">
            <Helmet>
                <title >{pageContent.title}</title>
                <meta name="description" content="" />
            </Helmet>
            <Navigation />

            <div className="page-content-wrap">
                <HorizontalNav title="BOKA COACH & KONSULT" />

                <div className="pt-5 pt-lg-0 page-content-inner">
                    {pageContent.image &&
                        <div className="course-img-wrap d-flex overflow-hidden position-relative" style={{maxHeight: '300px'}}>
                            <img src={pageContent.image} alt={pageContent.title} className="w-100" style={{objectFit: 'cover'}} />
                            <div className="course-img-overlay position-absolute w-100 h-100 d-flex justify-content-center align-items-center flex-column">
                                <div className="flex-grow-1 d-flex align-items-center">
                                    {/* <h2 className="text-white text-center">{topicTitle}</h2> */}
                                </div>
                            </div>
                        </div>
                    }

                    <div className="row justify-content-center g-0">
                        <div className="col-12 col-lg-11 content-pages pt-5 boka-coach-konsult">
                            <div className="px-3 px-lg-4" dangerouslySetInnerHTML={{__html: pageContent.content}}></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BookCoach;
